import React from "react"
import { Laptop, Smartphone, Users, Brain } from "lucide-react"
import Section from "../common/Section"
import { trackButtonClick } from "../../analytics"

const Services = ({ t }) => {
  const services = [
    {
      icon: <Users size={48} className="text-gray-500 group-hover:text-blue-500 transition-colors duration-300 mb-4" />,
      title: t.items[0].title,
      description: t.items[0].description,
    },
    {
      icon: <Laptop size={48} className="text-gray-500 group-hover:text-green-500 transition-colors duration-300 mb-4" />,
      title: t.items[1].title,
      description: t.items[1].description,
    },
    {
      icon: <Smartphone size={48} className="text-gray-500 group-hover:text-purple-500 transition-colors duration-300 mb-4" />,
      title: t.items[2].title,
      description: t.items[2].description,
    },
    {
      icon: <Brain size={48} className="text-gray-500 group-hover:text-orange-500 transition-colors duration-300 mb-4" />,
      title: t.items[3].title,
      description: t.items[3].description,
    },
  ]

  return (
    <Section id="services" className="bg-gray-100 text-gray-800">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-green-600">
        {t.sectionTitle}
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="bg-white p-8 rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105 flex flex-col items-center text-center group border-l-4 border-gray-200 hover:border-green-500"
            onMouseEnter={() => trackButtonClick(`service_hover_${service.title}`, 'services_section')}
          >
            <div className="p-3 rounded-full bg-gray-50 group-hover:bg-green-50 transition-colors duration-300 mb-2">
              {service.icon}
            </div>
            <h3 className="text-2xl font-semibold mb-3 text-gray-900 group-hover:text-gray-900">
              {service.title}
            </h3>
            <p className="text-gray-600">{service.description}</p>
            <div className="mt-4 w-12 h-1 bg-gray-200 group-hover:bg-gradient-to-r group-hover:from-green-400 group-hover:to-green-600 rounded-full transition-all duration-300"></div>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default Services
